import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ReadBlogFront from "../components/ReadBlogFront";
import BlogContent from "../components/BlogContent";

const ReadBlog = () => {
  return (
    <div>
        <Nav bg="nav-bg-color" />
        <ReadBlogFront/>
        <BlogContent/>        
        <Footer />
    </div>
  );
};

export default ReadBlog;
